/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
(function () {
  'use strict';

  angular.module('comcast.settings').controller('SettingsDestinationsSearchController', ['$location', '$q', '$state', '$stateParams', '$scope', 'loginService', 'MarketResourceFactory', 'DestinationTypeResourceFactory', function ($location, $q, $state, $stateParams, $scope, loginService, MarketResourceFactory, DestinationTypeResourceFactory) {
    /* PRIVATE : DATA */
    //Declare all private variables here

    /*
     * This is the `vm` object. It is a direct reference to the controller
     * which acts as our 'view-model' in angular. It also limits our need
     * to be accessing $scope directly. */

    /*jshint validthis:true*/
    var vm = this;
    /* BINDABLE : DATA */

    vm.searchParams = {};
    vm.markets = [];
    vm.destinationTypes = [];
    /* BINDABLE : METHODS*/

    vm.search = search;
    vm.clear = clear;
    vm.loadMarkets = loadMarkets;
    vm.loadDestinationTypes = loadDestinationTypes;
    /* EVENTS */
    //Register any event listeners

    /* INITIALIZATION */
    //Call controller initialization method here

    _init();
    /* IMPLEMENTATION : BINDABLE */


    function search() {
      $state.go('settingDestinations', vm.searchParams, {
        notify: true,
        inherit: false,
        reload: true
      });
    }

    function clear() {
      vm.searchParams = {};
    }

    function loadMarkets() {
      MarketResourceFactory.getAll({}, function (markets) {
        vm.markets = markets.data;
      }, function () {
        vm.markets = [];
      });
    }

    function loadDestinationTypes() {
      DestinationTypeResourceFactory.getAll({}, function (types) {
        vm.destinationTypes = types.data;
      }, function () {
        vm.destinationTypes = [];
      });
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /**
     * Initialization for this controller.
     */


    function _init() {
      vm.searchParams = $stateParams;
      vm.loadMarkets();
      vm.loadDestinationTypes();
    }
  }]);
})();